import { render, staticRenderFns } from "./guardService.vue?vue&type=template&id=5eb253bb&"
import script from "./guardService.vue?vue&type=script&lang=ts&"
export * from "./guardService.vue?vue&type=script&lang=ts&"
import style0 from "./guardService.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports